export const URL_TERMS_OF_SERVICE = "https://hallow.com/terms-of-service";
